import {getNavigationState} from '../../../shared/navigation-state'

export const RESERVED_PROFILE_URLS = new Set([
    'login', 'logout', 'signup', 'register', 'signin', 'auth', 'oauth', 'password', 'reset', 'verify', 'verification',
    'me', 'profile', 'profiles', 'account', 'accounts', 'settings', 'preferences', 'notifications', 'billing', 'subscription', 'subscriptions', 'premium', 'pro',
    'home', 'feed', 'following', 'explore', 'discover', 'search', 'map', 'maps', 'cities', 'city', 'countries', 'country', 'places', 'place', 'locations', 'photos', 'albums', 'collections', 'memories', 'journal', 'trips', 'trip', 'visited', 'wishlist',
    'about', 'team', 'jobs', 'careers', 'press', 'news', 'blog', 'contact', 'support', 'help', 'faq', 'status', 'roadmap',
    'privacy', 'terms', 'cookies', 'license', 'legal', 'security',
    'api', 'docs', 'developers', 'developer', 'graphql', 'webhooks', 'sdk',
    'admin', 'dashboard', 'staff', 'internal', 'moderator', 'mod', 'system', 'root', 'console',
    'www', 'cdn', 'mail', 'email', 'ftp', 'assets', 'static', 'public', 'private', 'media', 'images', 'img', 'uploads',
    'new', 'create', 'edit', 'delete', 'update', 'upload', 'download', 'invite', 'join', 'share',
    'outof195', 'out-of-195', '195', 'official', 'app',
    'network', 'rankings', 'followers', 'u',
])

export const isReservedProfileUrl = (value) => RESERVED_PROFILE_URLS.has(String(value || '').toLowerCase())

export const getProfilePath = (userOrUrl) => {
    const url = typeof userOrUrl === 'string' ? userOrUrl : (userOrUrl?.url || userOrUrl?.id)
    return url ? `/${url}` : '/profile'
}

const isProfileUrlSegment = (value) => /^[a-z0-9_-]+$/i.test(String(value || '')) && /[a-z0-9]/i.test(String(value || ''))
const getPathname = (value = '') => {
    const text = String(value || '')
    const pathStart = text.match(/^[a-z][a-z0-9+.-]*:\/\/[^/]*(\/.*)?$/i)?.[1] || text
    return pathStart.split(/[?#]/)[0]
}

export const isPublicProfilePath = (pathname = '') => {
    const parts = getPathname(pathname).split('/').filter(Boolean)
    if (parts.length === 0) return false
    if (parts[0] === 'u') return parts.length >= 2 && isProfileUrlSegment(parts[1])
    return isProfileUrlSegment(parts[0]) && !isReservedProfileUrl(parts[0])
}

export const isProfilePath = (pathname = '') => {
    const parts = getPathname(pathname).split('/').filter(Boolean)
    return parts[0] === 'profile' || isPublicProfilePath(pathname)
}

export {getNavigationPath} from '../../../shared/navigation-state'

export const getPreservedBackState = location => {
    const state = {
        ...(location.state?.from ? {from: location.state.from} : {}),
    }
    return Object.keys(state).length ? state : undefined
}

export const getProfileEntryState = getNavigationState

export const getProfileSubrouteOptions = location => ({
    state: getPreservedBackState(location),
    replace: true,
})
